<template>
    <div class="customerListBox">
        <!-- Query area -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t(I18N_KEY + 'mobile')">
                  <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'mobile'))" v-model="queryParam.mobileNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="12">
                <a-form-item :label="$t(I18N_KEY + 'curp')">
                  <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'curp'))" v-model="queryParam.curp"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :md="10" :sm="8">
                  <a-form-item :label="$t(I18N_KEY + 'createTime')">
                    <a-range-picker
                        v-model="queryParam.createdTime"
                        format="YYYY-MM-DD" />
                  </a-form-item>
                </a-col>
              </template>

              <a-col :md="6" :sm="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="loadData(1)" icon="search">{{ $t('search') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ $t(toggleSearchStatus ? 'hide' : 'show') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>

            </a-row>
          </a-form>
        </div>
        <a-table
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            bordered
            ref="table"
            size="middle"
            rowKey="id">
            <span slot="action" slot-scope="text, record">
                <a @click="handleDetail(record)">{{ $t('view') }}</a>
                <br/>
                <a @click="accountCancellation(record)" style="margin: 10px">Logout</a>
                <!-- <a @click="handleDetail2(record)">{{ 'xxx' }}</a> -->
            </span>
        </a-table>
        <div style="margin-top: 15px; text-align: right;">
            <v-pagination
                v-if="total"
                :page-num="form.pageNum"
                :page-size="form.pageSize"
                :total="total"
                @change="handleTableChange" />
        </div>
        <v-modal
            v-model="visible"
            :title="$t(I18N_KEY + 'customerDetail')">
            <div style="padding: 20px;">
                <customer-detail v-if="visible" :id="customerId" ref="customerDetail"/>
            </div>
        </v-modal>
        <!-- <customer-modal ref="customerModal"></customer-modal> -->
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment'
    import vModal from '../modules/Modal';
    import CustomerModal from './modules/CustomerModal'
    import CustomerDetail from './CustomerDetail';
    import Dict from '../modules/Dict';
    import DictSelect from '../modules/DictSelect';
    import md5 from 'md5'
    import { accountCancellation } from '@/webpublicapi/order'

    const I18N_KEY = 'customer.';
    export default {
        components: {
            Dict,
            DictSelect,
            vModal,
            CustomerDetail,
            CustomerModal
        },
        data () {
            return {
                moment,
                I18N_KEY,
                loading: false,
                customerId: undefined,
                form: {
                    pageNum: 1,
                    pageSize: 30,
                },
                defaultQueryParam: {
                    aadhaarNo: undefined,
                    mobileNo: undefined,
                    panNo: undefined,
                    createdTime: undefined,
                    beginDate: undefined,
                    endDate: undefined,
                },
                queryParam: {},
                visible: false,
                toggleSearchStatus: false,
            }
        },
        computed: {
            ...mapGetters('customer', [
                'customerList',
            ]),
            // Table header
            columns () {
                return [
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        key:'id',
                        width:60,
                        align:"center"
                    },
                    {
                        title: this.$t(I18N_KEY + 'mobile'),
                        align:"center",
                        dataIndex: 'mobileNo'
                    },
                    {
                        title: this.$t(I18N_KEY + 'firstName'),
                        align:"center",
                        dataIndex: 'names'
                    },
                    {
                        title: this.$t(I18N_KEY + 'middleName'),
                        align:"center",
                        dataIndex: 'surnames'
                    },
                    {
                      title: this.$t(I18N_KEY + 'curp'),
                      align:"center",
                      dataIndex: 'curp'
                    },
                    {
                      title: this.$t(I18N_KEY + 'createTime'),
                      align:"center",
                      dataIndex: 'createdTime'
                    },
                    {
                        title: this.$t('action'),
                        dataIndex: 'action',
                        align:"center",
                        scopedSlots: { customRender: 'action' },
                    }]
            },
            dataSource(){
              return (this.customerList && this.customerList.rows) || [];
            },
            total () {
                return this.customerList && this.customerList.total || 0;
            },
            pagination () {
                return {
                    pageSize: this.form.pageSize,
                    current: this.form.pageNum,
                    total: this.total,
                    showTotal: function(total) {
                      return "Total " + total + " records";
                    }
                }
            },
            element () {
                return document.querySelector('.aaa');
            }
        },
        watch: {
            roleList (data) {
                const list = (data && data.rows) || []
                list.length && (this.dataSource = list);
            }
        },
        created () {
            window.xx = this;
            this.getDict();
            this.basicForm = { ...this.defaultBasicForm };
            this.queryParam = { ...this.defaultQueryParam };
            // this.loadData();
        },
        methods: {
            ...mapActions('customer', [
                'getCustomerList'
            ]),
            modalContainer () {
                return document.querySelector('.customerListBox')
            },
            handleTableChange (pageNum, pageSize) {
                this.form.pageNum = pageNum;
                this.form.pageSize = pageSize;
                this.loadData();
            },
            handleToggleSearch(){
                this.toggleSearchStatus = !this.toggleSearchStatus;
            },
            transformMenuListToTree (list) {
                return list.map(item => {
                    return {
                        ...item,
                        value: '' + item.id,
                        title: item.nameEn || '',
                        key: '' + item.id,
                        children: this.transformMenuListToTree(item.children || [])
                    }
                })
            },
            transformStringToLow (str) {
                return str && str.toLocaleLowerCase();
            },
            changeModal (visible) {
                this.visible = visible;
            },
            requestMenuListAndRolePermission (id) {
                return Promise.all([
                    this.getMenuListTree(),
                    this.getRolePermission({ roleId: id }),
                ])
            },
            searchReset () {
                this.form = {
                    keywords: undefined,
                    pageNum: 1,
                    pageSize: 30,
                }
                this.queryParam = { ...this.defaultQueryParam };
                this.loadData(1);
            },
            handleDetail (row) {
                this.customerId = row.id;
                this.changeModal(true);
            },

          accountCancellation (record) {

            const self = this;
            this.$confirm({

              title: 'Deactivate Account',
              content: h => {
                return <div>
                  <div>
                    Verify Password:<input id = 'password' type = 'password' />
                  </div>
                </div>
              },
              onOk() {
                self.loading = true;
                var password = document.getElementById("password").value;

                if(!password.trim()){
                  alert('Verification password cannot be empty');

                  self.loadData();

                  return false;
                }

                var md5Password = md5(password);

                accountCancellation({ custId: record.id, password: md5Password}).then(res => {
                  if(res.code===1000){
                    self.loadData();
                  }else{
                    self.$message.error(res.msg);
                    self.loadData();
                  }

                }).catch(e => {
                  self.loading = false;
                  self.$message.error(e.message);
                })
              },
            });
          },
            transformTime (time) {
                return moment(time).format('YYYY-MM-DD')
            },
            loadData (pageNum) {
                if(pageNum) { this.form.pageNum = pageNum; }
                const { createdTime } = this.queryParam;
                const data = {
                    ...this.form,
                    ...this.queryParam,
                    beginDate: createdTime && this.transformTime(createdTime[0]),
                    endDate: createdTime && this.transformTime(createdTime[1]),
                }
                delete data.createdTime;
                this.loading = true;
                this.getCustomerList(data).then(res => {
                    this.loading = false;
                }).catch(e => {
                    this.loading = false;
                    this.$message.error(e.message);
                });
            }
        }
    }
</script>
<style scoped>
  @import '~@/assets/less/common.less';
</style>
